import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const CampaignStatsChart = ({ signupCount, participantCount, todaySignups }) => {
  const data = {
    labels: ['총 가입자', '이벤트 참여자', '오늘 가입자'],
    datasets: [
      {
        label: '참여자 수',
        data: [signupCount, participantCount, todaySignups],
        backgroundColor: [
          'rgba(75, 192, 192, 0.6)',
          'rgba(153, 102, 255, 0.6)',
          'rgba(255, 159, 64, 0.6)',
        ],
        borderColor: [
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
          'rgba(255, 159, 64, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    indexAxis: 'y',
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: '이벤트 주요 통계',
      },
    },
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        ticks: {
          crossAlign: 'center',
          padding: 10,
          textAlign: 'center',
          align: 'center',
          callback: function(value, index, ticks) {
            const label = this.getLabelForValue(value);
            const counts = [signupCount, participantCount, todaySignups];
            return [label, `${counts[index]} 명`];
          }
        },
      },
    },
  };

  return (
    <div style={{ position: 'relative', height: '100%', width: '100%' }}>
      <Bar options={options} data={data} />
    </div>
  );
};

export default CampaignStatsChart;
